/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Efforts_Precise_FtpInputs */

const en_ui_laps_efforts_precise_ftp = /** @type {(inputs: Ui_Laps_Efforts_Precise_FtpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add FTP for precise efforts`)
};

const de_ui_laps_efforts_precise_ftp = /** @type {(inputs: Ui_Laps_Efforts_Precise_FtpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FTP eintragen für genaue Belastungen`)
};

/**
* | output |
* | --- |
* | "Add FTP for precise efforts" |
*
* @param {Ui_Laps_Efforts_Precise_FtpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_efforts_precise_ftp = /** @type {((inputs?: Ui_Laps_Efforts_Precise_FtpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Efforts_Precise_FtpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_efforts_precise_ftp(inputs)
	return de_ui_laps_efforts_precise_ftp(inputs)
});